import * as React from 'react';
import {Button} from 'antd';
import locales from '../../locales';
import ButtonBar from '../../common/ButtonBar';
import {IncomingInvoice} from '../../api/dtos/dtos';
import {IncomingInvoiceState} from '../incoming-invoice-state';
import {PaymentType} from '../../common/PaymentType';
import {showConfirm, showDeleteConfirm} from '../../utils/dialogs';

interface Props {
  editable: boolean;
  invoice?: IncomingInvoice;
  onEditClicked: () => void;
  onDeleteConfirmed: () => void;
  onReopenConfirmed: () => void;
}

export default class InvoiceControlButtons extends React.Component<Props, {}> {
  public render() {
    const {editable, invoice} = this.props;
    const showReopen = invoice !== undefined
      && invoice.state !== IncomingInvoiceState.OPEN
      && invoice.paymentType === PaymentType.TRANSFER;

    return (
      <ButtonBar style={{marginBottom: 16}}>
        {showReopen &&
            <Button
                type="default"
                icon="rollback"
                onClick={this.onReopenClicked}
            >{locales.reopen}</Button>
        }
        <Button
          type="danger"
          icon="delete"
          onClick={this.onDeleteClicked}
        >{locales.delete}</Button>
        <Button
          type="primary"
          icon="edit"
          disabled={editable}
          onClick={this.props.onEditClicked}
        >{locales.edit}</Button>
      </ButtonBar>
    );
  }

  private onReopenClicked = () => {
    showConfirm(locales.reopen_confirm, this.props.onReopenConfirmed);
  };

  private onDeleteClicked = () => {
    showDeleteConfirm(this.props.onDeleteConfirmed);
  };
}


// WEBPACK FOOTER //
// ./src/incoming-invoices/details/InvoiceControlButtons.tsx